import React from 'react';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete'

class WizardItemLocationSearch extends React.Component {
	constructor(props) {
		super(props);
		this.state = { address: '' };
		this.handleChange = this.handleChange.bind(this);
		this.handleFromDropdown = this.handleFromDropdown.bind(this);
		this.findPostalCodeFromLatLng = this.findPostalCodeFromLatLng.bind(this);
		this.findCurrentLocation = this.findCurrentLocation.bind(this);
		this.validCountry = this.validCountry.bind(this);
		this.onChange = (address) => this.handleChange(address);
		this.selectFromDropdown = (address) => this.handleFromDropdown(address);
	}

	handleChange(address) {
		this.setState({ address: address });
	}

	handleFromDropdown(address) {
		var that = this;
		let geocoder = new google.maps.Geocoder();

		let postalCode = "";

		geocoder.geocode({ 'address': address }, function (results, status) {
			for (var i = 0; i < results[0].address_components.length; i++) {
				for (var j = 0; j < results[0].address_components[i].types.length; j++) {
					if (results[0].address_components[i].types[j] == "postal_code") {
						postalCode = results[0].address_components[i].long_name;
					}
				}
			}
			if (!postalCode) {
				that.findPostalCodeFromLatLng(results[0].geometry.location, address);
			}
			else {
				that.setState({ address: address });
				that.props.submitAnswer(postalCode);
			}
		});
	}

	findPostalCodeFromLatLng(latlng, address) {
		let that = this;
		let postalCode = "";
		let geocoder = new google.maps.Geocoder();

		geocoder.geocode({ 'location': latlng },
			function (newResults, status) {
				for (var i = newResults[0].address_components.length - 1; i >= 0; i--) {
					for (var j = newResults[0].address_components[i].types.length - 1; j >= 0; j--) {
						if (newResults[0].address_components[i].types[j] == "postal_code") {
							postalCode = newResults[0].address_components[i].long_name;
						}
					}
				}
				if (postalCode) {
					that.setState({ address: address });
					that.props.submitAnswer(postalCode);

				}
			});
	}

	validCountry(result) {
		var components = result.address_components;
		for (var i = 0; i < components.length; i++) {

			if (components[i].short_name.toLowerCase() == this.props.GoogleMapSettings.CountryRestrictions) {
				return true;
			}
		}
		return false;
	}

	findCurrentLocation() {
		let that = this;

		let defaultPosition;
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(function (position) {
				var pos = {
					lat: position.coords.latitude,
					lng: position.coords.longitude
				};

				defaultPosition = pos;

				var latLng = new google.maps.LatLng(pos.lat, pos.lng);
				var geoCoder = new google.maps.Geocoder();
				geoCoder.geocode({ 'latLng': latLng }, function (results, status) {
					if (status == google.maps.GeocoderStatus.OK) {
						that.findPostalCodeFromLatLng(results[0].geometry.location, results[0].formatted_address);

					}
				});

			}, function () {
				//for now dont so anything if on error

			});
		} else {
			// Browser doesn't support Geolocation
		}
	}

	render() {
		const inputProps = {
			value: this.state.address,
			onChange: this.onChange,
			placeholder: this.props.data.PlaceholderText,
			type: 'search'
		};

		const renderSuggestion = ({ suggestion }) => (
			<div className={(suggestion.active ? "suggestion-active" : "suggestion")}><i className="fa fa-map-marker" />{suggestion}</div>
		)

		const options = {
			componentRestrictions: {
				country: this.props.GoogleMapSettings.CountryRestrictions
			}
		};

		const icon = '<svg focusable="false" width="16" height="16" aria-hidden="true"><use xlink:href="/dist/svgsprite/icons.svg#Current-location_16x16"></use></svg>';
		return (
			<div>
				{this.props.mapsAPIloaded &&
					<div className="wizard-item wizard-item__single-line wizard-item__location-search">
						<PlacesAutocomplete
							inputProps={inputProps}
							renderSuggestion={renderSuggestion}
							onSelect={this.selectFromDropdown}
							options={options}
							styles={
								{
									autocompleteItem: {
										backgroundColor: '#F3F3F3'
									},
									autocompleteItemActive: {
										backgroundColor: 'rgba(0,0,0,0.1)'
									},
									autocompleteContainer: { 'position': 'relative' },

								}
							}
						/>

						<button className="current-location" id="useCurrentLocationButton" onClick={this.findCurrentLocation} >
							<span dangerouslySetInnerHTML={{ __html: icon }} />
							<span>{this.props.data.UseMyCurrentLocationText}</span>
						</button>
						<div className="powered-by-google u-margin-top-small"></div>
					</div>

				}
				<input type="hidden" value={JSON.stringify(this.state.address)} data-trackingid={this.props.data.QuestionTrackingId} />
			</div>
		)
	}
}

export default WizardItemLocationSearch;